// src/services/adapters/sightWordsDataAdapter.ts
import worksheetWordsData from '../../data/worksheet_words.json'

export type SightWordTier = 'tier1' | 'tier2' | 'tier3'
export type MoodType = 'overwhelmed' | 'high_energy' | 'steady'

export interface SightWordSelection {
  words: string[]
  wordCount: number
  tiers: SightWordTier[]
}

function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}

export function selectSightWordsForMood(mood: MoodType): SightWordSelection {
  const sightWordsData = (worksheetWordsData as any).sight_words
  const moodConfig = (worksheetWordsData as any).mood_configurations[mood]
  
  if (!sightWordsData) {
    throw new Error('Sight words not found in worksheet_words.json')
  }
  
  const wordCount = moodConfig.word_count
  let selectedWords: string[] = []
  
  // Mood determines tier selection strategy
  if (mood === 'overwhelmed') {
    // Only tier1 - highest frequency = most useful
    selectedWords = shuffleArray(sightWordsData.tier1.words).slice(0, wordCount)
  } else if (mood === 'steady') {
    // Mix tier1 + tier2
    const tier1Words = shuffleArray(sightWordsData.tier1.words).slice(0, 3)
    const tier2Words = shuffleArray(sightWordsData.tier2.words).slice(0, wordCount - 3)
    selectedWords = shuffleArray([...tier1Words, ...tier2Words])
  } else {
    // high_energy: Mix all tiers
    const tier1Words = shuffleArray(sightWordsData.tier1.words).slice(0, 3)
    const tier2Words = shuffleArray(sightWordsData.tier2.words).slice(0, 3)
    const tier3Words = shuffleArray(sightWordsData.tier3.words).slice(0, wordCount - 6)
    selectedWords = shuffleArray([...tier1Words, ...tier2Words, ...tier3Words])
  }
  
  return {
    words: selectedWords,
    wordCount: selectedWords.length,
    tiers: mood === 'overwhelmed' ? ['tier1'] : mood === 'steady' ? ['tier1', 'tier2'] : ['tier1', 'tier2', 'tier3']
  }
}